import ContactForm from "../../components/contact-form";
import axios from "axios";
import cogoToast from "cogo-toast";

const PoliceContainer = () => {
    const onSubmit = (data) => {
        axios
            .post(
                "https://soul-house-harmony.onrender.com/contact/contactus",
                data
            )
            .then((res) => {
                console.log(res);
                if (res.status === 200)
                    cogoToast.success("submitted successfully", {
                        position: "bottom-left",
                    });
            })
            .catch((err) => {
                console.log(err);
                cogoToast.info("Error submitting form", {
                    position: "bottom-left",
                });
            });
    };

    return (
        <div className="section contact-section bg-dark">
            <div className="container">
                <div className="row justify-content-end">
                    <div className="col-lg-12">
                        <div className="contact-section-wrapper">
                            <div className="contact-info" data-aos="fade-up">
                                <h2 className="mail">Privacy Policy</h2>
                            </div>
                            <div
                                className="pt-2"
                                style={{ textAlign: "justify" }}
                            >
                                <h4 className="pb-2">Introduction</h4>
                                <p>
                                    Soul Harmony is committed to protecting the
                                    privacy of its users and ensuring the
                                    confidentiality of all personal data
                                    provided through its mobile application.
                                    This policy outlines how we collect, use,
                                    and safeguard your personal information. By
                                    using our app, you agree to the terms of
                                    this privacy policy.
                                </p>
                                <h4 className="pb-2">Data Collection</h4>
                                <p>
                                    We collect personal and health-related data
                                    from users to provide a customized wellness
                                    experience through our services, including
                                    nutrition and psychology guidance. The
                                    information collected includes, but is not
                                    limited to:
                                </p>
                                <ul style={{ listStyleType: "circle" }}>
                                    <li>
                                        Personal identification data: Name,
                                        email, phone number
                                        <li>
                                            Health-related data: Lifestyle
                                            habits, dietary preferences, mental
                                            health assessments, and wellness
                                            goals
                                        </li>
                                        <li>
                                            Device data: Information about the
                                            device used to access the app for
                                            better functionality
                                        </li>
                                    </li>
                                </ul>
                                <h4 className="pb-2 pt-3">
                                    Objective of the Soul Harmony App
                                </h4>
                                <p>
                                    The primary objective of the Soul Harmony
                                    app is to seamlessly integrate psychology
                                    and nutrition to offer users a holistic
                                    approach to well-being. By merging data from
                                    both fields, we aim to provide users with
                                    comprehensive insights that help them
                                    understand how their mental health
                                    influences their nutritional habits and
                                    overall wellness, and vice versa. Users will
                                    receive an informative report based on their
                                    data, which they can use for personal health
                                    management or share with healthcare
                                    professionals for further consultation.
                                </p>
                                <h4 className="pb-2 pt-3">
                                    Purpose of Data Usage
                                </h4>
                                <p>Soul Harmony collects data to:</p>
                                <ul style={{ listStyleType: "circle" }}>
                                    <li>
                                        Provide Personalized Wellness Solutions:
                                        We use your health and personal
                                        information to offer tailored nutrition
                                        and psychological services.
                                        <li>
                                            Enhance User Experience: Personal
                                            data helps us improve user
                                            interactions, understand wellness
                                            progress, and adjust our
                                            recommendations.
                                        </li>
                                        <li>
                                            Support Health and Wellness Goals:
                                            We analyze user data to provide
                                            insights that foster holistic
                                            well-being across mind, body, and
                                            soul.
                                        </li>
                                    </li>
                                </ul>
                                <h4 className="pb-2 pt-3">
                                    Confidentiality and Data Security{" "}
                                </h4>
                                <p>
                                    All data shared by users through Soul
                                    Harmony is strictly confidential. We
                                    implement appropriate security measures,
                                    including encryption and secure servers, to
                                    protect sensitive information from
                                    unauthorized access or disclosure.
                                </p>
                                <h4 className="pb-2 pt-3">
                                    No Third-Party Sharing
                                </h4>
                                <p>
                                    Soul Harmony does not sell, rent, or share
                                    any personal or health-related information
                                    with third parties for marketing purposes.
                                    User data is solely used within the app to
                                    provide the services and improve user
                                    experience.
                                </p>
                                <h4 className="pb-2 pt-3">
                                    Accreditation and Compliance
                                </h4>
                                <p>
                                    Soul Harmony complies with the best
                                    practices and standards required for
                                    nutrition and psychology services. We
                                    utilize accredited nutritional and
                                    psychological systems to provide
                                    evidence-based recommendations, ensuring
                                    that our data handling adheres to privacy
                                    and medical confidentiality regulations.
                                </p>
                                <h4 className="pb-2 pt-3">Data Ownership</h4>
                                <p>
                                    The data entered into the Soul Harmony app
                                    is entirely owned by the user. You have full
                                    access to your records and can request
                                    modifications, deletion, or transfer of your
                                    data at any time. Users can opt to delete
                                    their account and data permanently.
                                </p>
                                <h4 className="pb-2 pt-3">User Consent</h4>
                                <p>
                                    By using Soul Harmony, you consent to the
                                    collection, storage, and use of your data as
                                    outlined in this policy. We only collect the
                                    data necessary for the app’s functionality,
                                    and users can withdraw their consent at any
                                    time by discontinuing the use of the app or
                                    requesting data deletion.
                                </p>
                                <h4 className="pb-2 pt-3">
                                    Changes to the Privacy Policy
                                </h4>
                                <p>
                                    Soul Harmony reserves the right to update
                                    this policy as required to comply with
                                    evolving legal requirements or enhance the
                                    service. We will notify users of any
                                    significant changes to this policy.
                                </p>

                                <p>
                                    Soul Harmony’s services are informed by the
                                    expertise of the founder, who holds a
                                    Master’s degree in Life Sciences and Drug
                                    Discovery from King’s College London,
                                    ensuring evidence-based practices in the
                                    integration of psychology and nutrition. The
                                    app delivers personalized recommendations
                                    with a foundation in credible, academic
                                    principles, always prioritizing user privacy
                                    and data security.
                                </p>

                                <p>
                                    The methodologies and recommendations
                                    provided within the Soul Harmony app are
                                    guided by principles derived from the
                                    founder’s expertise, holding a Master’s
                                    degree in Life Sciences and Drug Discovery
                                    from King’s College London.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PoliceContainer;
